// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fc3d66bd","453":"8a470b1b","455":"00e784fa","977":"ceaade2e"}[chunkId] + ".chunk.js";
};